<div class="nopadding">
    <div class="panel-heading nopadding">
        <div class="col-lg-3 col-md-3 col-sm-3 col-xs-3 ">           
        </div>
        <div class="col-lg-3 col-md-3 col-sm-3 col-xs-3 ">           
        </div>
        <div class="col-lg-3 col-md-3 col-sm-3 col-xs-3 ">           
        </div>    
        <div class="col-lg-3 col-md-3 col-sm-3 col-xs-3 nopadding">
            <span [ngClass]="equities === 1  ? 'dot downloadCompleted ' : 'dot downloading' "
            matTooltip="Equities" ></span>
            <span [ngClass]="IMIDlist === 1 ? 'dot downloadCompleted ' : 'dot downloading' " matTooltip="IMID list" ></span>
        <span [ngClass]="options === 1 ? 'dot downloadCompleted ' : 'dot downloading' " matTooltip="Options" ></span>
        </div>
    </div>
</div>
<div class="panel panel-default nopadding">
    <div class="panel-heading">
        <p class=" panel-title">Transaction and Exception Summary
        </p>
    </div>
    <div class="panel-body nopadding">
        <div style="display: block">
            <div class="row-eq-height">
                <div class="col-xs-12 rows">
                    <span class="table__cell">
                        <span> </span>
                        <b style="color: #4f5255">CAT Processing Date: </b>
                    </span>
                </div>
                <div class="title-style">
                    <strong>{{data?.summaryDataArray[0]?.catProcessingDate| date:'MM/dd/yyyy'}}</strong>
                </div>
            </div>
            <div class="nopadding">
                <table>
                    <tr class="bg-color">
                        <th style="width:28%">Reporting Summary</th>
                            <th style="width:15%"><span class="float-right"></span></th>
                        <th style="width:15%"><span class="float-right">DATA</span></th>
                        <th style="width:19%"><span class="float-right">ROE</span></th>
                        <th style="width:23%"><span class="float-right">Date</span></th>
                    </tr>
                    <tr class="bg-color">
                        @if(data){
                            <td></td>
                            <td><span class="float-right"></span></td>
                            <td><span class="float-right">{{data.summaryDataArray[0].reportingSummaryDataCount}}</span></td>
                            <td><span class="float-right">{{data.summaryDataArray[0].reportingSummaryROESSum}}</span></td>
                            <td><span class="float-right">{{data.summaryDataArray[0].reportingSummaryDateTime | date:'MM/dd/yyyy'}}</span></td>
                        }
                    </tr>
                </table>
                
                <table class="mg-t-2">
                    <tr class="bg-color">
                        <th style="width:28%"></th>
                        <th style="width:15%"></th>
                        <th style="width:15%"></th>
                        <th style="width:19%"></th>
                        <th style="width:23%"></th>
                    </tr>
                   
                    <tr>
                        <td><b>FINRA Submission </b></td>
                        <td><span class="float-right"></span></td>
                        @if(data){
                        <td><span class="float-right">{{data.summaryDataArray[0].finraCatSubDataCount}}</span></td>
                        <td><span class="float-right">{{data.summaryDataArray[0].finraCatSubROESum}}</span></td>
                        <td><span class="float-right">{{data.summaryDataArray[0].finraCatSubReportDate | date:'MM/dd/yyyy'}}</span></td>
                        }
                    </tr>
                </table>
                <table class="mg-t-2">
                    <tr class="bg-color">
                        <th style="width:28%"><b>CAT Feedback</b></th>
                        <th style="width:15%"><span class="float-right"><b>Ack</b></span></th>
                        <th style="width:15%"><span class="float-right"><b>Integrity</b></span></th>
                       
                        <th style="width:19%"><span class="float-right"><b>Ingestion</b></span></th>
                        <th style="width:23%"><span class="float-right"><b>Linkage</b></span></th>
                    </tr>
                    <tr>
                        @if(data){
                            <td><b>{{data.summaryDataArray[0].finraFeedbackDateTime| date:'MM/dd/yyyy HH:mm'}}</b></td>
                            <td><span class="float-right">{{data.summaryDataArray[0].finraACKStatus}}</span></td>
                            <td><span class="float-right">{{data.summaryDataArray[0].finraIntegrityROESSum}}</span></td>
                            <td><span class="float-right">{{data.summaryDataArray[0].finraIngestionROESSum}}</span></td>
                            <td><span class="float-right">{{data.summaryDataArray[0].finraLinkingROESSum}}</span></td>
                        }
                    </tr>
                </table>
                <table class="mg-t-2">
                    <tr>
                            <th style="width:28%">Open Exceptions</th>
                            <th style="width:15%"><span class="float-right">CAIS</span></th>
                            <th style="width:15%"><span class="float-right">CAT</span></th>
                            <th style="width:19%"><span class="float-right">FINRA CAT</span></th>
                            <th style="width:23%"><span class="float-right">Other</span></th>
                    </tr>
                    <tr>
                        @if(data){
                            <td></td>
                            <td><span class="float-right">{{data.averageDataArray[0].Curr_CAIS_Count}}</span></td>
                            <td><span class="float-right">{{data.averageDataArray[0].CAT_Open_Count}}</span></td>
                            <td><span class="float-right">{{data.averageDataArray[0].FINRA_CAT_Open_Count}}</span></td>
                            <td><span class="float-right">{{data.averageDataArray[0].Other_Open_Count}}</span></td>
                        }
                    </tr>
                   
                </table>
                <table class="mg-t-2">
                    <tr>
                            <th style="width:30%"></th>
                            <th style="width:29%"></th>
                            <th style="width:45%"></th>
                    </tr>
                    
                    <tr>
                        <td></td>
                        <td><b class="float-right">Current</b></td>
                        <td><b class="float-right">30 Day Average </b></td>
                    </tr>
                    @if(data){
                        
                        @if(data.averageDataArray[0]){
                            <tr>
                                <td><b>Orders</b></td>
                                <td><span class="float-right">{{data.averageDataArray[0].Curr_Order_Count}}</span></td>
                                <td><span class="float-right">{{data.averageDataArray[0].Avg_Order_Count}}</span></td>
                            </tr>
                            <tr>
                                <td><b>Routes</b></td>
                                <td><span class="float-right">{{data.averageDataArray[0].Curr_Route_Count}}</span></td>
                                <td><span class="float-right">{{data.averageDataArray[0].Avg_Route_Count}}</span></td>
                            </tr>

                            <tr>
                                <td><b>Trades</b></td>
                                <td><span class="float-right">{{data.averageDataArray[0].Curr_Trade_Count}}</span></td>
                                <td><span class="float-right">{{data.averageDataArray[0].Avg_Trade_Count}}</span></td>
                            </tr>
                            <tr>
                                <td><b>CAT ROE</b></td>
                                <td><span class="float-right">{{data.averageDataArray[0].Curr_CAT_Count}}</span></td>
                                <td><span class="float-right">{{data.averageDataArray[0].Avg_CAT_Count}}</span></td>
                            </tr>
                            <tr >
                                <td><b>CAIS</b></td>
                                <td><span class="float-right">{{data.averageDataArray[0].Curr_CAIS_Count}}</span></td>
                                <td><span class="float-right">{{data.averageDataArray[0].Avg_CAIS_Count}}</span></td>
                            </tr>
                        }
                    }
                </table>
            </div>
        </div>
    </div>
</div>